/**
 * Created by BFR on 23/05/2017.
 */
define('adminResTransDetailsView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'app',
  'settings',
  'imageUtils',
  'template!adminResTransDetailsTpl',
  'adminResTransTabs',
  'rolesMixin',
  'backToListBehavior'
], function (
  module,
  Marionette,
  _,
  Backbone,
  App,
  Settings,
  imageUtils,
  viewTpl,
  restransTabs,
  RolesMixin,
  BackToListBehavior
) {
  'use strict';

  var ResTransDetailsView =  Marionette.LayoutView.extend({
    template: viewTpl,

    ui: {
      tab: '.restrans-tab',
      tabPane: '.tab-pane',
      logo: '.js-logo-holder',
      name: '.p-name',
      code: '.p-code'
    },

    // events: {
    //   'change @ui.collectionToggle': 'onCollectionToggle'
    // },

    regions: {
      restransDetailTab: '#detail-tab'
    },

    behaviors: function() {
      var redirectUrl = 'admin/lmbanas/'+this.options.model.get('refLmbAna').secId+'/restrans';
      return {
        BackToList: {
          behaviorClass: BackToListBehavior,
          redirectUrl: redirectUrl
        }
      };
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.restransTabs = restransTabs;
      templateData.compulogoCollection = this.model.get('compulogoCollection');
      return templateData;
    },

    onRender: function() {
      if (this.options.data.tab) {
        this.ui.tab.removeClass('active');
        this.$el.find('.tab-pane').removeClass('active');
        this.$el
          .find('.restrans-tab[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
        this.$el
          .find('.tab-pane[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
      }
    },

    onShow: function() {
      $.material.init();
    }
  });

  module.exports = ResTransDetailsView;
});
